<template>
    <div class="wrapper">
        <div class="info-block">
            Edit organization brand settings
        </div>
        <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        >
            <v-container fluid>
            <v-layout row>
                <v-flex class="section">
                    <div class="section-title"> {{ alreadyHasBranding ? 'Update': 'Create' }} Brand Configuration</div>
                    <v-layout row wrap>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Brand URL </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-if="!alreadyHasBranding"
                                    label="Insert brand URL"
                                    v-model="form.url"
                                    :rules="rules.upradeBrandUri"
                                    outline
                                    single-line
                                ></v-text-field>
                                <v-text-field
                                    v-if="alreadyHasBranding"
                                    label="Insert brand URL"
                                    v-model="form.url"
                                    :rules="rules.url"
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs6>
                                <div class="label text-xs-right text-box text-box-powered">
                                    <span class="text-xs-right">Show powered by<span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs6>
                                    <v-checkbox v-model="form.showPoweredBy"></v-checkbox>
                            </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Primary color </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <input type="color" id="primary-color" v-model="form.primaryColor" class="color-picker" name="primary-color">
                            </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Secondary color </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <input type="color" id="secondary-color" v-model="form.secondaryColor" class="color-picker" name="secondary-color">
                            </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Font color </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <input type="color" id="font-color" v-model="form.fontColor" class="color-picker" name="font-color">
                            </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Icon primary color  </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <input type="color" id="icon-secondary-color" v-model="form.iconPrimaryColor" class="color-picker" name="secondary-color">
                            </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6>
                            <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right text-box">
                                    <span class="text-xs-right"> Icon secondary color  </span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <input type="color" id="icon-primary-color" v-model="form.iconSecondaryColor" class="color-picker" name="primary-color">
                            </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                    </v-layout>
                    <v-layout justify-space-between row>
                        <sp-button @click.native="resetColors" :disabled="canResetColors" :text="canResetColors ? 'Colors are default' : 'Reset Colors'" icon="reset"></sp-button>
                        <sp-button @click.native="updateBrandSettings" text="Save" icon="download"></sp-button>
                    </v-layout>
                    <div class="images-content" v-if="alreadyHasBranding">
                        <div class="section-title section-image"> Add Brand Images </div>
                        <v-layout row justify-center>
                            <div class="dropBox">
                                <div class="drop-info">
                                    <div class="drop-image">
                                        <img src="@/assets/images/icon-drop-here.png" alt="" />
                                    </div>
                                    <div class="drop-text">
                                        Click select to upload image file
                                    </div>
                                    <div class="drop-input">
                                        <input type="file" class="file" @change="addImage" />
                                        <sp-button sp-class="no-padding-right" small-icon icon="arrow-left" text="Select image to upload"></sp-button>
                                    </div>
                                </div>
                            </div>
                        </v-layout>
                        <v-layout row justify-center>
                            <div class="add-devices">
                                <div v-if="file != null" class="file-list">
                                    <div class="file-list__file"
                                        :key="`file_${file.name}_${file.lastModified}`">
                                        <v-layout row>
                                            <img src="@/assets/icons/icon-images.svg" class="icon-image" width="16">
                                            {{ file.name }}
                                            <button class="remove-file align-center" @click="clearFile">
                                                <i class="material-icons">close</i>
                                            </button>
                                        </v-layout>
                                    </div>
                                </div>
                            </div>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex md8>
                                <v-layout row>
                                    <v-flex xs3>
                                        <div class="label text-xs-right text-box">
                                            <span class="text-xs-right">Image type<span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            :items="allowedImageTypes"
                                            v-model="imageType"
                                            label="Select an image type"
                                            item-text="key"
                                            item-value="id"
                                            required
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex md4>
                                <v-layout justify-end row>
                                    <sp-button @click.native="uploadImage" sp-class="no-padding-right" icon="add" text="Add image"></sp-button>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                            <div class="section-title section-image"> Uploaded Brand Images </div>
                        <v-layout row>
                            <div class="uploaded-images-list">
                                <div v-if="!form.images[0]"> Brand has no updated images </div>
                                <v-layout row v-for="image of form.images" :key="image.id" justify-space-between class="image-record">
                                    <v-flex xs2>
                                        <span> {{ mapImageType(image.type) }} </span>
                                    </v-flex>
                                    <v-flex xs8>
                                        <div class="img">
                                        <a :href="`${image.uri}`" target="_blank">
                                            <span> {{ shortUri(image.uri) }} </span>
                                        </a>
                                        </div>
                                    </v-flex>
                                    <v-layout justify-end xs2>
                                        <sp-button @click.native="deleteImage(image.id)" design-type="table-button" sp-class="width-auto" icon="delete"></sp-button>
                                    </v-layout>
                                </v-layout>
                            </div>
                        </v-layout>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        </v-form>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>

import SpButton from '@/components/forms/Button'
import BrandApi from '@/api/BrandApi'
import OrganizationApi from '@/api/OrganizationApi'
import toast from '@/plugins/izitoast'
import scssVariables from '@/assets/scss/_variables.scss'
import { mapGetters, mapActions } from 'vuex'
import { searchEnumById } from '@/helpers/Utils'
import { isValidUrl } from '@/helpers/Validators'
import SpLoader from '@/components/atoms/Loader'

const brandApi = new BrandApi()
const organizationApi = new OrganizationApi()

export default {
    name: 'OrganizationBrandSettings',
    async mounted () {
        this.id = this.$route.params.organizationUuid
        await this.getOrganizationId()
        this.imageTypes()
    },
    components: {
        SpButton,
        SpLoader
    },
    data () {
        return {
            dialog: false,
            valid: false,
            dropped: false,
            dropzone: false,
            file: null,
            brandId: null,
            isLoading: true,
            imageType: 1,
            defaultPrimary: scssVariables.primaryDefault,
            defaultSecondary: scssVariables.secondaryDefault,
            iconPrimaryDefault: scssVariables.iconPrimaryDefault,
            iconSecondaryDefault: scssVariables.iconSecondaryDefault,
            defaultFontColor: scssVariables.fontDefault,
            allowedImageTypes: [],
            form: {
                url: null,
                showPoweredBy: false,
                primaryColor: '#db1238',
                secondaryColor: '#1d2a39',
                iconPrimaryColor: '#ffffff',
                iconSecondaryColor: '#db1238',
                fontColor: '#ffffff',
                images: []
            },
            alreadyHasBranding: false,
            allowedExtensions: [
                'image/png',
                'image/jpg',
                'image/jpeg',
                'image/gif',
                'image/vnd.microsoft.icon'
            ],
            rules: {
                upradeBrandUri: [
                    v => ((50 >= (v || '').trim().length) || !v) || 'Brand URL must less than 50 characters',
                    v => (isValidUrl(v) || !v) || 'Entered URL is not valid'
                ],
                url: [
                    v => ((50 >= (v || '').trim().length) || !v) || 'Brand URL must less than 50 characters',
                    v => (isValidUrl(v) || !v) || 'Entered URL is not valid'
                ]
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getBrandImageTypes'
        ]),
        ...mapGetters('authModule', [
            'getActiveOrganization'
        ]),
        canResetColors () {
            return this.defaultPrimary === this.form.primaryColor &&
                   this.defaultSecondary === this.form.secondaryColor &&
                   this.defaultFontColor === this.form.fontColor &&
                   this.iconPrimaryDefault === this.form.iconPrimaryColor &&
                   this.iconSecondaryDefault === this.form.iconSecondaryColor
        }
    },
    watch: {
        'getBrandImageTypes': function (newVal, oldVal) {
            this.imageTypes()
        },
        'brandId': function (newVal, oldVal) {
            if (this.brandId) this.getBrandingSettings()
        }
    },
    methods: {
        ...mapActions({
            setBranding: 'brandModule/setBranding'
        }),
        async getOrganizationId () {
            this.isLoading = true
            const response = await organizationApi.getOrganizationById(this.id)
            if (!response.isSuccess) {
                this.isLoading = false
                return
            }
            this.brandId = response.payload.organizationBrandId
            this.isLoading = false
        },
        async getBrandingSettings () {
            this.isLoading = true
            const response = await brandApi.getBrandById(this.id)
            if (!response.isSuccess) {
                this.alreadyHasBranding = false
                return
            }
            this.form.url = response.payload.url
            this.form.showPoweredBy = response.payload.showPoweredBy
            this.form.primaryColor = null === response.payload.primaryColor ? this.defaultPrimary : response.payload.primaryColor
            this.form.secondaryColor = null === response.payload.secondaryColor ? this.defaultSecondary : response.payload.secondaryColor
            this.form.iconPrimaryColor = null == response.payload.iconPrimaryColor ? this.iconPrimaryDefault : response.payload.iconPrimaryColor
            this.form.iconSecondaryColor = null == response.payload.iconSecondaryColor ? this.iconSecondaryDefault : response.payload.iconSecondaryColor
            this.form.fontColor = null === response.payload.fontColor ? this.defaultFontColor : response.payload.fontColor
            this.form.images = response.payload.images
            this.alreadyHasBranding = true
            this.isLoading = false
            this.resetDialog()
        },
        async updateBrandSettings () {
            if (!this.validate()) return
            if (this.alreadyHasBranding) {
                const response = await brandApi.updateBrand({
                    organizationId: this.id,
                    url: this.form.url,
                    primaryColor: this.defaultPrimary === this.form.primaryColor ? null : this.form.primaryColor,
                    secondaryColor: this.defaultSecondary === this.form.secondaryColor ? null : this.form.secondaryColor,
                    fontColor: this.defaultFontColor === this.form.fontColor ? null : this.form.fontColor,
                    iconPrimaryColor: this.iconPrimaryDefault === this.form.iconPrimaryColor ? null : this.form.iconPrimaryColor,
                    iconSecondaryColor: this.iconSecondaryDefault === this.form.iconSecondaryColor ? null : this.form.iconSecondaryColor,
                    showPoweredBy: this.form.showPoweredBy
                })
                if (!response.isSuccess) {
                    return
                }
                toast.success('Brand successfully updated.')
            } else if (!this.alreadyHasBranding) {
                const response = await brandApi.createBrand({
                    organizationId: this.id,
                    url: this.form.url ? this.form.url : null,
                    primaryColor: this.defaultPrimary === this.form.primaryColor ? null : this.form.primaryColor,
                    secondaryColor: this.defaultSecondary === this.form.secondaryColor ? null : this.form.secondaryColor,
                    fontColor: this.defaultFontColor === this.form.fontColor ? null : this.form.fontColor,
                    iconPrimaryColor: this.iconPrimaryDefault === this.form.iconPrimaryColor ? null : this.form.iconPrimaryColor,
                    iconSecondaryColor: this.iconSecondaryDefault === this.form.iconSecondaryColor ? null : this.form.iconSecondaryColor,
                    showPoweredBy: this.form.showPoweredBy
                })
                if (!response.isSuccess) {
                    return
                }
                toast.success('Brand successfully created.')
            }
            this.afterBrandUpdate()
        },
        addImage (event) {
            this.dropped = true
            this.previewFile(event.target.files)
        },
        previewFile (files) {
            if (1 < files.length) {
                toast.error('You can upload only one file.')
                return
            }
            if (!this.allowedExtensions.includes(files[0].type)) {
                toast.error(files[0].type + ' type is not allowed.')
                this.dropped = false
                this.file = null
                return
            }
            this.file = files[0]
        },
        resetDialog () {
            this.valid = false
            this.dropped = false
            this.dropzone = false
            this.file = null
        },
        clearFile () {
            this.resetDialog()
        },
        shortUri (uri) {
            if (50 > uri.length) return uri
            return uri.slice(0, 20) + '...' + uri.slice(uri.length - 90, uri.length - 64) + '...'
        },
        mapImageType (imageTypeInt) {
            let imageTypeText = searchEnumById(this.getBrandImageTypes, imageTypeInt)

            return imageTypeText || ''
        },
        async uploadImage () {
            if (false === this.dropped) {
                toast.error('You have to upload a file')
                return
            }

            let image = new FormData()

            image.append('image', this.file)
            image.append('OrganizationId', this.id)
            image.append('Type', this.imageType)

            const response = await brandApi.addImage(image)

            if (!response.isSuccess) {
                return
            }

            toast.success('Image successfully uploaded')

            this.afterBrandUpdate()
        },
        async deleteImage (id) {
            const response = await brandApi.deleteImage(id)
            if (!response.isSuccess) {
                return
            }

            toast.success('Image successfully deleted')
            this.afterBrandUpdate()
        },
        validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            } else {
                return true
            }
        },
        afterBrandUpdate () {
            if (this.id === this.getActiveOrganization) {
                this.setBranding()
            }
            this.getBrandingSettings()
        },
        imageTypes () {
            const allowedImageTypeNumbers = [1, 2, 3, 4]
            this.allowedImageTypes = this.getBrandImageTypes.filter(el => allowedImageTypeNumbers.includes(el.id))
        },
        resetColors () {
            this.form.primaryColor = this.defaultPrimary
            this.form.secondaryColor = this.defaultSecondary
            this.form.fontColor = this.defaultFontColor
            this.form.iconPrimaryColor = this.iconPrimaryDefault
            this.form.iconSecondaryColor = this.iconSecondaryDefault
        }
    }
}
</script>

<style scoped lang="scss">
.wrapper {
    .section-title {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
    }
    .info-block {
        margin-bottom: 20px;
    }
    .section-image {
        margin-top: 20px;
    }
    .label {
        position: relative;
        margin-bottom: 5px;

        &--category {
            font-weight: 700;
        }

    }
    .icon-image {
        margin-right: 5px;
    }

    .section {
        padding: 0 10px;

        &:last-child {
            border-right-color: transparent;
        }
        .text-box {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 48px;
        }
        .text-box-powered {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 48px;
        }

        .required {
            margin-left: 2px;
            color: red
        }
    }
}
.uploaded-images-list {
    margin: 5px auto;
    width: 90%;
}
.add-image-error-box {
    width: 100%;
    margin: 5px auto 15px auto;
}
.align-center {
    display: flex;
    align-items: center;
}
.file-list__file {
    margin: 10px 0 20px 0;
}
.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
.notification-group {
    margin-bottom: 0px;
}

.notification-checkbox {
    margin-left: 5px !important;

    ::v-deep &.v-input .v-input__slot {
        min-height: 0 !important;
    }
}

.image-record {
    border-bottom: 1px dotted gray;
    margin-bottom: 10px;
}
.email {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 5px 0;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }

    ::v-deep .btn {
        margin: 0;
    }
}

.email-input {
    ::v-deep &.v-input .v-input__slot {
        border-top-right-radius: 0!important;
        border-bottom-right-radius: 0!important;
    }
}
.color-picker {
    border-radius: 4px;
    height: 50px;
    padding: 5px 9px;
    margin-bottom: 28px;
    cursor: pointer;
}

.dropBox {
    border: 3px solid $gray;
    padding: 30px 15px;
    background: $white;
    min-height: 100px;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    .drop-image {
        text-align: center;
    }

    .drop-text {
        text-align: center;
        font-size: 22px;
    }

    .drop-input {
        position: relative;
        margin-top: 10px;
        display: flex;
        justify-content: center;

        .file {
            position: absolute;
            z-index: 9;
            opacity: 0;
        }
    }

    .images {
        width: 100%;
        .image-box {
            display: inline-block;
            width: 200px;
            height: 150px;
            margin: 10px;

            img {
                position: relative;
                max-width: 100%;
                max-height: 100%;
                transform: translateY(-50%);
                top: 50%;
            }
        }
    }
}

</style>
